import { Link } from 'react-router-dom'
import { QapaqLogo } from '../components/QapaqLogo'
import '../styles/landing.css'

export default function LandingPage() {
  return (
    <div className="landing">
      <Navbar />
      <Hero />
      <Stats />
      <ComoFunciona />
      <ParaQuien />
      <Confianza />
      <CtaFinal />
      <Footer />
    </div>
  )
}

/* ── Navbar ─────────────────────────────────────────────────── */
export function Navbar() {
  return (
    <nav className="ln-nav">
      <div className="ln-nav__inner">
        <Link to="/" className="ln-nav__logo">
          <img src="/qapaq-logo.jpg" alt="QAPAQ" height={48} style={{ display: 'block', objectFit: 'contain' }} />
        </Link>

        <ul className="ln-nav__links">
          <li><Link to="/como-funciona">Cómo funciona</Link></li>
          <li><Link to="/empresas">Empresas</Link></li>
          <li><Link to="/transportistas">Transportistas</Link></li>
        </ul>

        <div className="ln-nav__actions">
          <Link to="/app/login" className="ln-btn ln-btn--outline">Entrar</Link>
          <Link to="/app/registro" className="ln-btn ln-btn--primary">Registrarse</Link>
        </div>
      </div>
    </nav>
  )
}

/* ── Hero ───────────────────────────────────────────────────── */
function Hero() {
  return (
    <section className="ln-hero">
      <div className="ln-hero__inner">
        <span className="ln-hero__tagline">Plataforma logística — Chile</span>
        <h1 className="ln-hero__title">
          Conecta carga.<br />Conecta caminos.
        </h1>
        <p className="ln-hero__sub">
          Publica tu carga, recibe cotizaciones en minutos y rastrea tus envíos en tiempo real.
          La forma más simple de mover lo que necesitas a lo largo de Chile.
        </p>
        <div className="ln-hero__ctas">
          <Link to="/app/registro" className="ln-btn ln-btn--white-solid ln-btn--xl">
            Publicar carga
          </Link>
          <Link to="/app/registro" className="ln-btn ln-btn--outline-white ln-btn--xl">
            Soy transportista
          </Link>
        </div>
        <div className="ln-hero__scroll">
          <div className="ln-hero__scroll-line" />
          Conoce más abajo
        </div>
      </div>
    </section>
  )
}

/* ── Stats ──────────────────────────────────────────────────── */
function Stats() {
  const items = [
    { num: '16',      label: 'Regiones de Chile' },
    { num: '24/7',    label: 'Disponibilidad' },
    { num: 'GPS',     label: 'Tracking en tiempo real' },
    { num: '100%',    label: 'Trazabilidad digital' },
  ]
  return (
    <div className="ln-stats">
      <div className="ln-stats__inner">
        {items.map(i => (
          <div className="ln-stat" key={i.label}>
            <div className="ln-stat__num">{i.num}</div>
            <div className="ln-stat__label">{i.label}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

/* ── Cómo funciona ──────────────────────────────────────────── */
function ComoFunciona() {
  const pasos = [
    {
      num: '01',
      icon: '📦',
      title: 'Publica tu carga',
      text: 'Ingresa origen, destino, tipo de carga y peso. Elige entre remate instantáneo o cotización planificada. Listo en 2 minutos.',
    },
    {
      num: '02',
      icon: '🤝',
      title: 'Recibe cotizaciones',
      text: 'Transportistas calificados de toda la red Qapaq cotizan tu carga. Compara precios, reviews y acepta la mejor oferta.',
    },
    {
      num: '03',
      icon: '📍',
      title: 'Rastrea en tiempo real',
      text: 'Sigue tu envío en el mapa con GPS en vivo. Recibe alertas automáticas en cada punto del trayecto hasta la entrega.',
    },
  ]
  return (
    <section className="ln-section ln-como" id="como-funciona">
      <div className="ln-container">
        <div className="ln-section-label">Proceso</div>
        <h2 className="ln-section-title">Cómo funciona</h2>
        <p className="ln-section-sub">
          Tres pasos y tu carga ya está en camino. Sin llamadas, sin papeleos, sin demoras.
        </p>
        <div className="ln-steps">
          {pasos.map(p => (
            <div className="ln-step" key={p.num}>
              <div className="ln-step__num">{p.num}</div>
              <div className="ln-step__icon">{p.icon}</div>
              <div className="ln-step__title">{p.title}</div>
              <p className="ln-step__text">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

/* ── Para quién ─────────────────────────────────────────────── */
function ParaQuien() {
  return (
    <section className="ln-section ln-para-quien" id="para-quien">
      <div className="ln-container">
        <div className="ln-section-label">Quiénes usamos Qapaq</div>
        <h2 className="ln-section-title">Una plataforma,<br />dos mundos</h2>
        <div className="ln-cards">
          <div className="ln-card ln-card--empresas">
            <span className="ln-card__badge">Empresas y personas</span>
            <div className="ln-card__icon">📦</div>
            <h3 className="ln-card__title">Necesito mover carga</h3>
            <p className="ln-card__text">
              Desde pymes hasta grandes empresas. Publica tu requerimiento y recibe cotizaciones
              de transportistas verificados en minutos.
            </p>
            <ul className="ln-card__list">
              <li>Cotizaciones en tiempo real</li>
              <li>Transportistas calificados y verificados</li>
              <li>Entrega confirmada con QR</li>
              <li>Tracking GPS de tu envío</li>
              <li>Historial completo de cargas</li>
            </ul>
            <Link to="/app/registro" className="ln-btn ln-btn--primary ln-btn--lg">
              Publicar mi primera carga
            </Link>
          </div>

          <div className="ln-card ln-card--transportistas">
            <span className="ln-card__badge">Transportistas</span>
            <div className="ln-card__icon">🚛</div>
            <h3 className="ln-card__title">Tengo camión y busco trabajo</h3>
            <p className="ln-card__text">
              Accede a las cargas publicadas en toda la red. Filtra por origen, tipo de
              vehículo y precio. Cobras directo al oferente: QAPAQ no se queda con tu pago.
            </p>
            <ul className="ln-card__list">
              <li>Alertas de remates por región</li>
              <li>Filtros por tipo de vehículo</li>
              <li>Chat directo con el oferente</li>
              <li>Gestión de flota y documentos</li>
              <li>Control GPS y reportes de ruta</li>
            </ul>
            <Link to="/app/registro" className="ln-btn ln-btn--outline-white ln-btn--lg">
              Registrar mi camión
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

/* ── Confianza ──────────────────────────────────────────────── */
function Confianza() {
  const items = [
    { icon: '🇨🇱', title: 'Empresa chilena', text: 'Operamos desde Hijuelas, Región de Valparaíso, y funcionamos en las 16 regiones del país.' },
    { icon: '📜', title: 'Documentos digitales', text: 'Registra el número de la guía de despacho del oferente, confirma la entrega con QR y conserva la trazabilidad de cada envío.' },
    { icon: '⭐', title: 'Sistema de ranking', text: 'Calificamos transportistas y oferentes. Cada entrega construye o resta reputación en la plataforma.' },
    { icon: '🔒', title: 'Datos protegidos', text: 'Tu información viaja cifrada y cada usuario solo accede a los datos de su propia cuenta y empresa.' },
    { icon: '📞', title: 'Soporte por WhatsApp', text: 'Canal de soporte directo vía WhatsApp Business. Respuesta rápida para problemas urgentes en ruta.' },
    { icon: '💳', title: 'Pay per use', text: 'Sin mensualidades obligatorias. Pagas solo por los envíos que realizas. Planes Pro disponibles.' },
  ]
  return (
    <section className="ln-section ln-trust" id="confianza">
      <div className="ln-container">
        <div className="ln-section-label">Por qué elegirnos</div>
        <h2 className="ln-section-title">Confianza en cada kilómetro</h2>
        <p className="ln-section-sub">
          Construida en Chile, para el transporte chileno. Cada feature fue diseñado con transportistas y empresas reales.
        </p>
        <div className="ln-trust-grid">
          {items.map(i => (
            <div className="ln-trust-item" key={i.title}>
              <div className="ln-trust-item__icon">{i.icon}</div>
              <div>
                <div className="ln-trust-item__title">{i.title}</div>
                <p className="ln-trust-item__text">{i.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

/* ── CTA Final ──────────────────────────────────────────────── */
export function CtaFinal() {
  return (
    <section className="ln-cta-final">
      <div className="ln-container">
        <h2 className="ln-cta-final__title">
          Tu carga ya tiene<br />
          <span>su camino.</span>
        </h2>
        <p className="ln-cta-final__sub">
          Únete a la red logística que está cambiando cómo se mueve Chile.
        </p>
        <div className="ln-cta-final__actions">
          <Link to="/app/registro" className="ln-btn ln-btn--primary ln-btn--xl">
            Crear cuenta gratis
          </Link>
          <Link to="/app/login" className="ln-btn ln-btn--outline-white ln-btn--xl">
            Ya tengo cuenta
          </Link>
        </div>
        <p className="ln-cta-final__note">Sin tarjeta de crédito · Sin contrato · Cancela cuando quieras</p>
      </div>
    </section>
  )
}

/* ── Footer ─────────────────────────────────────────────────── */
export function Footer() {
  return (
    <footer className="ln-footer">
      <div className="ln-footer__inner">
        <div className="ln-footer__top">
          <div>
            <div className="ln-footer__brand-name">QAPAQ</div>
            <p className="ln-footer__brand-desc">
              Plataforma logística chilena que conecta empresas y transportistas
              a lo largo de todo el país.
            </p>
          </div>
          <div>
            <div className="ln-footer__col-title">Plataforma</div>
            <ul className="ln-footer__links">
              <li><Link to="/app/registro">Registrarse</Link></li>
              <li><Link to="/app/login">Ingresar</Link></li>
              <li><Link to="/como-funciona">Cómo funciona y preguntas frecuentes</Link></li>
              <li><Link to="/empresas">Para empresas</Link></li>
              <li><Link to="/transportistas">Para transportistas</Link></li>
            </ul>
          </div>
          <div>
            <div className="ln-footer__col-title">Empresa</div>
            <ul className="ln-footer__links">
              <li><Link to="/quienes-somos">Quiénes somos</Link></li>
              <li><a href="mailto:contacto@qapaq.cl">contacto@qapaq.cl</a></li>
              {/* 0.16 — Se retira el enlace de WhatsApp: apuntaba a un número de
                  relleno. Vuelve cuando el de Business esté operativo. */}
              <li><Link to="/app/terminos">Términos y condiciones</Link></li>
              <li><Link to="/app/privacidad">Privacidad</Link></li>
            </ul>
          </div>
        </div>
        <div className="ln-footer__bottom">
          <span className="ln-footer__copy">© {new Date().getFullYear()} Qapaq. Todos los derechos reservados.</span>
          <span className="ln-footer__rut">RUT 78.415.721-0</span>
        </div>
      </div>
    </footer>
  )
}
